import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn() — the standard className combiner.
 *
 * `clsx` handles conditional/object class lists; `twMerge` then resolves
 * conflicting Tailwind utilities so that *later* classes win — e.g.
 * `cn('bg-black bg-opacity-50', 'bg-opacity-60')` yields `bg-opacity-60`,
 * which is what lets callers override a component's default styling from
 * `className` without specificity fights or duplicated attributes.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
